import React from 'react';
import { loadMeowContract } from '../util/StandardGetters.js'
import { weiToWholeMeow } from '../util/Utils'
import NumberFormat from 'react-number-format'

async function loadVoteStatusData(accounts) {
  const { contract: meow } = await loadMeowContract(accounts);

  let itLen = await meow.methods.voteIteratorLength().call();
  itLen = itLen.toNumber();

  const gets = []
  const voteCounts = [];
  for (let i = 0; i < itLen; i++) {
    gets.push(
      meow.methods.voteIterator(i).call().then(address =>
        meow.methods.voteCounts(address).call().then(c => {
          voteCounts.push([address, c]);
        })
      )
    )
  }

  await Promise.all(gets);

  return {
    meow,
    voteCounts
  };
}

export const requiredData = {
  name: 'votestatus',
  get: loadVoteStatusData
}

export default function VoteStatus(props) {
  const { voteCounts } = props.votestatus;

  voteCounts.sort((a, b) => a[1].gt(b[1]) ? -1 : 1);

  return (
    <>
      <h1 className='voteList'>Current Candidates</h1>
      {voteCounts.map(([account, count]) =>
        <React.Fragment key={account}>
          <div className='voteDisplayAddress'>{account}</div>
          <small className='voteDisplayAmount'>
            <NumberFormat value={weiToWholeMeow(count.toString())} displayType={'text'} thousandSeparator={true} />
          </small>
        </React.Fragment>
      )}
    </>
  )
}
